import { render, staticRenderFns } from "./Gtva.vue?vue&type=template&id=0335896e&"
import script from "./Gtva.vue?vue&type=script&lang=js&"
export * from "./Gtva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports